import { AssistantRepository } from "@core/data/repositories/assistant.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteAssistantConversationUseCase {
    constructor(
        @inject(AssistantRepository)
        private readonly repository: AssistantRepository,
    ) {}

    async execute(id: number): Promise<Either<FallbackError, true>> {
        return this.repository.deleteConversation(id);
    }
}
